const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // Force NEW address form to Kuwait only
      const newCountry = document.getElementById('AddressCountryNew');
      if (newCountry) {
        this._restrictToKuwait(newCountry, 'AddressProvinceNew', 'AddressProvinceContainerNew');
      }

      // Loop through edit address forms
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        this._restrictToKuwait(
          document.getElementById(`AddressCountry_${formId}`),
          `AddressProvince_${formId}`,
          `AddressProvinceContainer_${formId}`
        );
      });
    }
  }

  

  _restrictToKuwait(countrySelect, provinceId, provinceContainerId) {
    if (!countrySelect) return;

    // Remove all options except Kuwait
    [...countrySelect.options].forEach((opt) => {
      if (opt.value !== "Kuwait") opt.remove();
    });

    // Force Kuwait to be selected
    countrySelect.value = "Kuwait";

    // Init Province Selector
    new Shopify.CountryProvinceSelector(countrySelect.id, provinceId, {
      hideElement: provinceContainerId,
    });

    // Auto trigger change to load provinces
    countrySelect.dispatchEvent(new Event("change"));

    
    const provinceSelect = document.getElementById(provinceId);
    if (provinceSelect && provinceSelect.dataset.default) {
      provinceSelect.value = provinceSelect.dataset.default;
    }
  }


  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}



document.querySelectorAll("li[data-address] > a").forEach(anchor =>
  anchor.addEventListener("click", e => {
    e.preventDefault();
    const li = anchor.parentElement;
    li.classList.toggle("active");

    const btn = li.querySelector(".edittheaddress");
    if (btn) {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", !expanded);
    }
  })
);

document.querySelectorAll('button[type="reset"], .edittheaddress').forEach(el =>
  el.addEventListener('click', () => {
    const li = el.closest('li[data-address]');
    if (!li) return;
    li.classList.toggle('active');
    const topOffset = li.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({
      top: topOffset,
      behavior: 'smooth'
    });
  })
);




document.querySelectorAll('input[name="default_address"]').forEach(radio => {
  radio.addEventListener('click', () => {
    const li = radio.closest('li');
    if (!li) return;

    const checkbox = li.querySelector('input[name="address[default]"]');
    if (checkbox) {
      checkbox.checked = true;
    }

    const updateBtn = li.querySelector('.addresses-update');
    if (updateBtn) {
      updateBtn.click(); 
    }
  });
});

document.querySelectorAll(".mobile-account-toggle  a").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    e.currentTarget.closest(".user-navigation").classList.toggle("active-nav");
  });
});




